import { parseApiDateTime } from './parseApiDateTime'
import { DEFAULT_API_DATE_TIME_FORMAT } from './apiDateTimeFormats.constants'

export const formatApiDateTime = (value?: string | null, format = DEFAULT_API_DATE_TIME_FORMAT) => {
  const dateTime = parseApiDateTime(value)
  if (!dateTime) return 'N/A'
  return dateTime.toFormat(format)
}
